import { Icons } from "../../Components"
import type { PlayerSquareProps, SquareProps, SquaresCompetitionProps } from "../../types"
import React, { useState } from "react"
import { Button, Text, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"

type BoardStatsProps = {
    squares_competition:SquaresCompetitionProps,
    squares:SquareProps[],
    hidden?:boolean,
    disable_collapse?:boolean,
    player_squares:PlayerSquareProps[],
}

const BoardStats = ({ hidden, disable_collapse, squares_competition, squares, player_squares}:BoardStatsProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);

    let total_payout = squares_competition.potential_winnings
    if(squares_competition.guaranteed_payout && squares_competition.guaranteed_payout > total_payout){ total_payout = squares_competition.guaranteed_payout }
    let iteration_payout = total_payout / squares_competition.payout_frequency
    let active_ps = player_squares.filter(ps => ps.status == 'active');
    const ownership_pct = active_ps.length / squares.length * 100
    if(hidden){ return <></> }
    return (
        <View float style={{ minWidth:350, borderRadius:0 }}>
                <Button disabled={disable_collapse} style={{ flexDirection:'row', alignItems:'center', backgroundColor:C.views.header, borderRadius:0 }} onPress={() => setExpanded(!expanded)}>
                    <Icons.PieIcon color={C.text.h1} size={18} />
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme="h1">BOARD STATS</Text>
                        <Text style={{ marginTop: 4 }} theme="description">Current statistics from the squares board</Text>
                    </View>
                    {!disable_collapse ?
                    <Icons.ChevronIcon direction={expanded ? 'up' : 'down'} color={C.text.h1} size={8} />
                    :<></>}
                </Button>
                {expanded ?
                <View transparent style={{ padding:10 }}>
                    <View transparent type='row'  style={{ borderBottomWidth:1, borderColor:C.borders.light, padding:10 }}>
                        <View transparent style={{flex:1, marginRight:10}}>
                            <Text theme="h2">Unbid Squares</Text>
                            <Text style={{ marginTop:3 }} theme="description">Percent of the board that has no bids</Text>
                        </View>
                        <Text theme="h2">{(squares.length - active_ps.length).toFixed()} ({(100 - ownership_pct).toFixed(2)}%)</Text>
                    </View>
                    <View transparent type='row'  style={{ borderBottomWidth:1, borderColor:C.borders.light, padding:10 }}>
                        <View transparent style={{flex:1, marginRight:10}}>
                            <Text theme="h2">Current Total Payout</Text>
                            <Text style={{ marginTop:3 }} theme="description">The current total amount to be paid out to the winners</Text>
                        </View>
                        <Text size={16} color={C.text.success} weight='bold'>${total_payout.toFixed(2)}</Text>
                    </View>
                    <View transparent type='row'  style={{ borderBottomWidth:1, borderColor:C.borders.light, padding:10 }}>
                        <View transparent style={{flex:1, marginRight:10}}>
                            <Text theme="h2">Current Iteration Payout</Text>
                            <Text style={{ marginTop:3 }} theme="description">The current amount to be paid out per quarter</Text>
                        </View>
                        <Text size={16} color={C.text.success} weight='bold'>${iteration_payout.toFixed(2)}</Text>
                    </View>
                </View>
                :<></>}
            </View>
    )
}

export default BoardStats